import { Text } from '@nextui-org/react'
import { useNavigate } from 'react-router-dom'

import './index.css'

export default ({}) => {
    const navigate = useNavigate()

    return (
        <>
            <div className="gl-menu-bar">
                <ul>
                    {/* <li onClick={() => {
                        // document.querySelector('#how-it-works').scrollIntoView({behavior: "smooth"})
                    }}>
                        <Text b size="$sm" color='#11181c'>For Start-ups</Text>
                    </li> */}
                    <li onClick={() => navigate('/opportunities')}><Text b size="$sm">Opportunities</Text></li>
                    {/* <li onClick={() => {
                        // document.querySelector('#services').scrollIntoView({behavior: "smooth"})
                    }}>
                        <Text b size="$sm" color='#11181c'>For Academics</Text>
                    </li> */}
                </ul>
            </div>
        </>
    )
}